// extracted by mini-css-extract-plugin
export default {"sectionWrap":"creatividadesSection_sectionWrap__1WLlg"};